module.exports = {"product":"Product","products":"Producten","name":"Naam","group":"Rubiriek","vat_category":"BTW","price":"Prijs","description":"Omscrijving","list":{"title":"Producten"},"manage":{"edit":"Producten wijzigen","create":"Nieuwe producten aanmaken"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/product.json
// module id = u6RF
// module chunks = 9